import type { FC } from "react";
import { Button, Modal, Text } from "@uhg-harmony/react";
import type { ModalProps } from "@uhg-harmony/react";
import { ErrorContainer } from "./shared";
import styles from "./Delete.module.css";

type DeleteModalProps = ModalProps & {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  templateName?: string;
  isLoading?: boolean;
  errorMessage?: string;
  publishedVersionCount?: number;
};

export const DeleteModal: FC<DeleteModalProps> = ({
  title,
  open,
  onClose,
  onConfirm,
  templateName,
  isLoading = false,
  errorMessage = "",
  publishedVersionCount = 0,
}) => {
  return (
    <>
      {open && (
        <Modal open={open} title={title} aria-label={typeof title === 'string' ? title : 'Delete Template'} onClose={onClose}>
          <Modal.Body>
            {errorMessage && (
              <ErrorContainer>
                <strong>Error:</strong> {errorMessage}
              </ErrorContainer>
            )}
            <Text size="xlarge">
              Are you sure you want to delete
              {templateName ? ` "${templateName}"` : " this template"}? This
              action cannot be undone.
            </Text>
            {publishedVersionCount > 0 && (
              <Text
                size="large"
                className={styles.criticalAlert}
              >
                ⛔ Critical: Deleting this template will permanently remove it
                and all {publishedVersionCount} published {publishedVersionCount === 1 ? "version" : "versions"}. This will directly impact production
                email delivery. This action is irreversible.
              </Text>
            )}
          </Modal.Body>

          <Modal.Actions>
            <Button variant="secondary" onPress={onClose} isDisabled={isLoading}>
              Cancel
            </Button>
            <Button
              variant="destructive"
              onPress={onConfirm}
              isDisabled={isLoading}
            >
              {isLoading ? "Deleting..." : "Delete"}
            </Button>
          </Modal.Actions>
        </Modal>
      )}
    </>
  );
};